import { LitElement, html, css } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
export class SaveCount extends LitElement {
	static styles = [
		css`
			:host,
			:host > div,
			div {
				display: flex;
				align-items: center;
				line-height: 1;
			}

			.indicator {
				width: 8px;
				height: 8px;
				border-radius: 50%;
				background: transparent;
			}

			@keyframes liked {
				0% {
					transform: scale(0.8);
				}
				25% {
					transform: scale(1.2);
				}
				50% {
					transform: scale(1);
				}
				75% {
					transform: scale(1.1);
				}
				100% {
					transform: scale(1);
				}
			}

			@keyframes pulse {
				0% {
					transform: scale(1);
				}
				25% {
					transform: scale(1.25);
				}
				50% {
					transform: scale(1);
				}
				75% {
					transform: scale(1.25);
				}
				100% {
					transform: scale(1);
				}
			}

			.indicator.active {
				background: #ff0200;
				animation: liked 450ms ease-in-out;
			}

			.indicator.active[pulse] {
				animation: pulse 1250ms ease-in-out;
			}
		`,
	];

	static properties = {
		count: { type: Number },
		type: { type: String },
		classes: { type: Object },
		_indicator: { state: true },
	};

	constructor() {
		super();
		this.count = localStorage.getItem('_hos-saved-list')
			? JSON.parse(localStorage.getItem('_hos-saved-list')).length
			: 0;
		this.classes = { indicator: true, active: this.count > 0 };
		this._indicator = this.count > 0;
	}
	connectedCallback() {
		super.connectedCallback();

		window.MicroBus.on('save-items:change', (e) => {
			this.count = e.detail.count;
			this.classes = { indicator: true, active: this.count > 0 };
			if (this.count > 0) {
				this._indicator = true;
				setTimeout(() => {
					this._indicator = false;
				}, 450);
			}
		});

		window.MicroBus.on('save-items:count-change', (e) => {
			this.count = e.detail.count;
			this.classes = { indicator: true, active: this.count > 0 };
			if (this.count > 0) {
				this._indicator = true;
				setTimeout(() => {
					this._indicator = false;
				}, 450);
			}
		});
	}

	render() {
		if (this.type === 'text') {
			return html`${this.count} ${this.count === 1 ? 'item' : 'items'}`;
		} else if (this.type === 'indicator') {
			return html`<div
				class=${classMap(this.classes)}
				?pulse=${this._indicator}
			></div>`;
		} else if (this.type === 'number' || !this.type) {
			return html`${this.count}`;
		}
	}
}
if (!customElements.get('save-count'))
	customElements.define('save-count', SaveCount);
